<!-- Global Modals Component -->
<template>
  <div>
    <!-- Add your global modals here -->
    <!-- Example: -->
    <!-- <EnquireModal v-model:show="showEnquireModal" /> -->
  </div>
</template>

<script setup lang="ts">
// Import your modal components here
// import EnquireModal from '~/layers/base/components/vehicles/EnquireModal.vue'
</script> 